import { ProfileAdapterV2BalanceQuery } from '@s7/profile';
import { Self } from '../../../shared/self';
export var useBalance = Self.query(ProfileAdapterV2BalanceQuery);
